import React from 'react';

import Modal from '../../../commonComponents/util/Modal';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import ValidatedInput from '../../../commonComponents/util/ValidatedInput';
import RadioGroup from '../../../commonComponents/util/RadioGroup';
import CityInput from './CityInput';
import FadeOutErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';

import {Departments} from '../../../../lib/systemVariables';

import {deepEquals} from '../../../../lib/utils';

export default class LocationGroupModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            locationGroup: {
                groupName: '',
                department: Departments.US,
                members: []
            },
            groupId: '',
            error: false,
            submitAttempted: false
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!deepEquals(nextProps.locationGroup, this.props.locationGroup) && nextProps.locationGroup.groupId) {
            const {groupName, members, department} = nextProps.locationGroup;
            this.setState({locationGroup: {groupName, members, department}});
        }
    }

    onChange(name, value) {
        this.setState({locationGroup: {...this.state.locationGroup, ...{[name]: value}}});
    }

    updateDepartment(name, value) {
        this.setState({locationGroup: {...this.state.locationGroup, [name]: value, members: []}});
    }

    async onSubmit() {
        this.setState({error: false, submitAttempted: true});
        const locationGroup = Object.assign({}, {
            groupName: this.state.locationGroup.groupName,
            department: this.state.locationGroup.department,
            members: [...this.state.locationGroup.members]
        });
        if (!locationGroup.groupName || (locationGroup.department === Departments.US && !locationGroup.members.length)) return;
        if (this.props.locationGroup.members.length) {
            delete locationGroup.department;
            await this.props.updateLocationGroup(locationGroup);
            if (this.props.updatingSuccess) {
                this.props.reloadCampaignSettings();
                this.onClose();
            } else this.setState({error: true});
        } else {
            //This is in order for the backend to know that this location group is for any recipient with an address that has country of ישראל
            if (!locationGroup.members.length && locationGroup.department === Departments.IL) locationGroup.members.push({
                city: '',
                state: '',
                country: 'ישראל'
            });
            await this.props.addLocationGroup(locationGroup);
            if (this.props.addingSuccess) {
                this.props.reloadCampaignSettings();
                this.onClose();
            } else this.setState({error: true});
        }
    }

    onClose() {
        this.props.close();
        this.setState({
            locationGroup: {
                groupName: '',
                members: [],
                department: Departments.US
            },
            error: false,
            submitAttempted: false
        });
    }

    render() {
        const {locationGroup} = this.state;
        let disabled = false;
        let editMode = false;
        if (this.props.locationGroup.members.length) {
            editMode = true;
            let locationGroup = { ...this.props.locationGroup};
            delete locationGroup.groupId;
            if (deepEquals(locationGroup, this.state.locationGroup)) disabled = true;
        }
        return (

            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal new-transaction-modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">{editMode ? 'Edit' : 'Add New'} Location Group</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>
                        <div className="modal-section">

                            <div className="modal-row modal-row-full-width">
                                {editMode ?
                                    <div>
                                        <label className="input-label">Department</label>
                                        <label>{locationGroup.department}</label>
                                    </div>
                                    : <RadioGroup onChange={this.updateDepartment.bind(this)} options={[{
                                        key: Departments.US,
                                        value: 'US - $ - Check Printing'
                                    }, {key: Departments.IL, value: 'IL - ₪ - Wiring'}]}
                                                  title="Which department is this location group for?" name="department"
                                                  value={locationGroup.department}/>}
                            </div>

                            <div className="modal-row modal-row-full-width">
                                <ValidatedInput input={<input type="text"/>}
                                                label="Location Group Name" name="groupName"
                                                value={locationGroup.groupName} onChange={this.onChange}
                                                required={true} showRequiredError={this.state.submitAttempted}/>
                            </div>

                            <div className="modal-row modal-row-full-width">
                                {(editMode && (locationGroup.department === Departments.IL && locationGroup.members.length === 1 && !locationGroup.members[0].city))
                                ? <label>This location group includes all cities in ישראל.</label>
                                : <CityInput isIsraeli={locationGroup.department === Departments.IL}
                                           required={locationGroup.department === Departments.US}
                                           showRequiredError={this.state.submitAttempted} values={locationGroup.members}
                                           updateValues={(vals) => this.setState({
                                               locationGroup: {
                                                   ...this.state.locationGroup,
                                                   members: vals
                                               }
                                           })}/>}
                            </div>

                        </div>
                        {this.props.loading ? <LoadingSpinner height="20" alignRight={true}/> :
                            <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                <button className="btn btn-primary" disabled={disabled}
                                        onClick={this.onSubmit}>{editMode ? 'Update' : 'Add'}</button>
                                <FadeOutErrorMessage show={this.state.error}/>
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}

//pass through departments....


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/campaignSettings/LocationGroupModal.jsx